export default __webpack_public_path__ + "static/media/banner_1_2W.92b01497.jpg";